import { DealConfidenceLevelId, DealConfidenceLevelResponse } from '@business/entities/deal';
import { Endpoint } from '@business/api/endpoint';

export interface DealConfidenceLevelData {
  name?: string;
  color?: string;
}

export function fetchDealConfidenceLevels() {
  return Endpoint.get<DealConfidenceLevelResponse[]>(`@gc/deal-confidence-levels`);
}

export function createDealConfidenceLevel(data: DealConfidenceLevelData) {
  return Endpoint.post<DealConfidenceLevelResponse[]>(`@gc/deal-confidence-levels`, { data });
}

export function updateDealConfidenceLevel(id: DealConfidenceLevelId, data: DealConfidenceLevelData) {
  return Endpoint.patch<DealConfidenceLevelResponse[]>(`@gc/deal-confidence-levels/${id}`, { data });
}

export function deleteDealConfidenceLevel(id: DealConfidenceLevelId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/deal-confidence-levels/${id}`);
}

export function sortDealConfidenceLevels(ids: DealConfidenceLevelId[]) {
  return Endpoint.post<DealConfidenceLevelResponse[]>(`@gc/deal-confidence-levels/sort`, { data: { ids } });
}
